(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/views/receivers.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/views/receivers.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.grassroots_shared_2=_svs.grassroots_shared_2||{};
_svs.grassroots_shared_2.templates=_svs.grassroots_shared_2.templates||{};
svs.grassroots_shared_2.templates.receivers = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"grassroots\" class=\"\">\n  <div class=\"receivers-app\" />\n</div>\n\n";
},"useData":true});
Handlebars.partials['svs-grassroots_shared_2-receivers'] = svs.grassroots_shared_2.templates.receivers;
})(svs, Handlebars);


 })(window);